import React, { FunctionComponent } from "react";
import createSvgIcon from "@mui/icons-material/utils/createSvgIcon";

// SVG taken from https://materialdesignicons.com/icon/arrow-collapse-horizontal
export default createSvgIcon(
	<path d="M13,20V4H15.03V20H13M10,20V4H12.03V20H10M5,8L9.03,12L5,16V13H2V11H5V8M20,16L16,12L20,8V11H23V13H20V16Z" fill="currentColor" />
	, "ArrowCollapseHorizontal",
);

